export default __webpack_public_path__ + "static/media/location.d15e458b.svg";